import React from 'react';

const ContainerNotFound = () => <h2>Unable to find a container with that ID. Please try again.</h2>;

export default ContainerNotFound;
